export enum ProspectSource {
  PERSONAL = 'personal',
  SALES_REFERRAL = 'sales-referral',
  B2B = 'b2b',
}
